module.exports = __webpack_public_path__ + "static/mihai-stefan-0_G9UHXy39c-unsplash-5cf4966668007ef9a048488c7fd83ae8.png";